import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restrict-access',
  templateUrl: './restrict-access.component.html',
  styleUrls: ['./restrict-access.component.scss']
})
export class RestrictAccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
